import React from 'react'
import HeaderPage from '../../components/HeaderPage'
import ProductsTabsIndex from './components/productsTabsIndex'

function Products() {
  return (
    <>
      <HeaderPage title={'Productos'} />
      <ProductsTabsIndex />
    </>
  )
}

export default Products
